<template>
  <span class="cy-chip" :class="[`cy-chip--${tone}`, `cy-chip--${size}`, { 'cy-chip--upper': upper }]">
    <slot />
  </span>
</template>

<script setup>
// Small notched status/format chip — the shop's replacement for
// rounded badge pills. Mono, dense, cut on two corners at --cy-notch-sm.
// (No vue runtime APIs used — defineProps is a compiler macro.)
defineProps({
  /* 'signal' (primary) | 'alarm' (accent) | 'neutral' (dim) */
  tone: { type: String, default: 'neutral' },
  /* 'sm' | 'md' */
  size: { type: String, default: 'sm' },
  upper: { type: Boolean, default: true }
})
</script>

<style scoped>
.cy-chip {
  --cy-n: 6px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  clip-path: polygon(
    var(--cy-n) 0, 100% 0,
    100% calc(100% - var(--cy-n)), calc(100% - var(--cy-n)) 100%,
    0 100%, 0 var(--cy-n)
  );
  font-family: var(--cy-mono);
  font-weight: 600;
  letter-spacing: 0.08em;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cy-chip--upper { text-transform: uppercase; }

.cy-chip--sm { font-size: 0.6rem;  padding: 3px 7px; }
.cy-chip--md { font-size: 0.68rem; padding: 4px 10px; --cy-n: var(--cy-notch-sm); }

.cy-chip--neutral {
  background: color-mix(in srgb, var(--cy-ground) 55%, transparent);
  color: color-mix(in srgb, var(--text-main) 82%, transparent);
}
.cy-chip--signal {
  background: rgb(var(--primary-channels) / 0.16);
  color: var(--primary);
}
.cy-chip--alarm {
  background: color-mix(in srgb, var(--accent) 18%, transparent);
  color: color-mix(in srgb, var(--accent) 85%, var(--text-main) 15%);
}
</style>
